import React from 'react';
import Hero from '../components/home/Hero';
import ProblemCards from '../components/home/ProblemCards';
import SolutionWorkflow from '../components/home/SolutionWorkflow';
import ModuleTabs from '../components/home/ModuleTabs';
import WhyActula from '../components/home/WhyActula';
import StatsBar from '../components/home/StatsBar';
import Personas from '../components/home/Personas';
import CBAMUrgency from '../components/home/CBAMUrgency';
import FAQ from '../components/home/FAQ';
import FinalCTA from '../components/home/FinalCTA';

export default function Home(): React.ReactElement {
  return (
    <main>
      <Hero />
      <ProblemCards />
      <SolutionWorkflow />
      <ModuleTabs />
      <WhyActula />
      <StatsBar />
      <Personas />
      <CBAMUrgency />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
